import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StickyBottomBar } from './components/StickyBottomBar';
// Lazy load todo lo que está debajo del fold para mejorar TTI
const TargetAudienceSection = lazy(() => import('./components/TargetAudienceSection').then(m => ({
  default: m.TargetAudienceSection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const UniqueMechanismSection = lazy(() => import('./components/UniqueMechanismSection').then(m => ({
  default: m.UniqueMechanismSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const AuthorSection = lazy(() => import('./components/AuthorSection').then(m => ({
  default: m.AuthorSection
})));
const CTASection = lazy(() => import('./components/CTASection').then(m => ({
  default: m.CTASection
})));
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(m => ({
  default: m.PurchaseNotifications
})));
function SectionSkeleton() {
  return <div className="w-full py-24 bg-[#0D002B] animate-pulse" aria-hidden="true" data-id="element-0" />;
}
const waves = {
  W1: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-1">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-2">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-3" />
      </svg>
    </div>,
  W2: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-4">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-5">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-6" />
      </svg>
    </div>,
  W3: () => <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-7">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-8">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-9" />
      </svg>
    </div>,
  W4: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-10">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-11">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-12" />
      </svg>
    </div>,
  W5: () => <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-13">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-14">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-15" />
      </svg>
    </div>,
  W6: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-16">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-17">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-18" />
      </svg>
    </div>,
  W7: () => <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-19">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-20">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-21" />
      </svg>
    </div>,
  W8: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-22">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-23">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-24" />
      </svg>
    </div>
};
export function App() {
  const [bannerTime, setBannerTime] = useState(2 * 3600 + 10 * 60 + 52);
  useEffect(() => {
    const timer = setInterval(() => {
      setBannerTime(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    document.title = 'Rescate Clave de Paz | Salva tu relación';
    const meta = document.querySelector('meta[name="description"]');
    const content = 'Descubre el método práctico para reconstruir la comunicación, sanar heridas y blindar tu pareja contra las crisis financieras y el agotamiento mental.';
    if (meta) meta.setAttribute('content', content);else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = content;
      document.head.appendChild(newMeta);
    }
    // Preconnect CDN
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(link);
    // Pixel diferido — no bloquea render, pero el stub queueing en pixel.ts
    // garantiza que los clicks rápidos también se trackeen.
    setTimeout(() => {
      import('./utils/pixel').then(({
        initPixel
      }) => initPixel());
    }, 1500);
  }, []);
  const {
    W1,
    W2,
    W3,
    W4,
    W5,
    W6,
    W7,
    W8
  } = waves;
  return <div className="w-full min-h-screen bg-[#110038] text-white font-sans" data-id="element-25">
      {/* Marquee Urgency Banner — sticky top */}
      <div className="sticky top-0 z-50 w-full bg-[#ffa605] text-black py-2.5 overflow-hidden shadow-md" data-id="element-26">
        <div className="flex whitespace-nowrap animate-marquee" data-id="element-27">
          {[...Array(4)].map((_, i) => <span key={i} className="text-sm font-bold tracking-wide inline-flex items-center gap-2 px-8" data-id="element-28">
              ⏳ OFERTA POR TIEMPO LIMITADO:&nbsp;
              <span className="text-[#c0392b]" data-id="element-29">53% OFF</span>
              &nbsp;—&nbsp;Precio normal&nbsp;
              <span className="line-through opacity-60" data-id="element-30">$24.999</span>
              &nbsp;→ HOY&nbsp;
              <span className="text-[#057a01] font-extrabold" data-id="element-31">$11.749 ARS</span>
              &nbsp;—&nbsp;⚡ Al llegar a cero, el precio vuelve a $24.999
            </span>)}
        </div>
      </div>

      {/* HeroSection y StickyBar cargan sin lazy — son críticos */}
      <HeroSection data-id="element-32" />

      <Suspense fallback={<SectionSkeleton data-id="element-34" />} data-id="element-33">
        <W1 data-id="element-35" />
        <TargetAudienceSection data-id="element-36" />
        <W2 data-id="element-37" />
        <ProblemSection data-id="element-38" />
        <W3 data-id="element-39" />
        <UniqueMechanismSection data-id="element-40" />
        <W4 data-id="element-41" />
        <BonusSection data-id="element-42" />
        <W5 data-id="element-43" />
        <AuthorSection data-id="element-44" />
        <W6 data-id="element-45" />
        <CTASection data-id="element-46" />
        <W7 data-id="element-47" />
        <TransformationSection data-id="element-48" />
        <W8 data-id="element-49" />
        <FAQSection data-id="element-50" />
        <W1 data-id="element-51" />
        <Footer data-id="element-52" />
        <PurchaseNotifications data-id="element-53" />
      </Suspense>
    </div>;
}